var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoteActivity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8743 9.83802L14.2851 9.24877L6.03553 17.4984H2.5V13.9628L11.9281 4.53469L16.6422 9.24877C16.9676 9.57419 16.9676 10.1019 16.6422 10.4273L10.7496 16.3198L9.57108 15.1413L14.8743 9.83802ZM15.4636 2.17767L17.8207 4.53469C18.1461 4.86013 18.1461 5.38777 17.8207 5.7132L16.6422 6.89171L13.1066 3.35618L14.2851 2.17767C14.6106 1.85224 15.1382 1.85224 15.4636 2.17767Z",
    fill: "#9CA2A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteActivity);
export default __webpack_public_path__ + "static/media/note-activity.e279a252928e6d82f041bf1d47ff9339.svg";
export { ForwardRef as ReactComponent };